const paperStyles = {
  padding: "8px 12px 8px 14px",
  minHeight: "40px",
  display: "flex",
  alignItems: "center"
};
export {
  paperStyles
};
